function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { sendLinkEvent } from './analytics';
export var DEFAULTS = Object.freeze({
  errorPlacementDefault: 'top',
  defaultAnalyticsFunction: sendLinkEvent,
  alertSendsAnalytics: false,
  buttonSendsAnalytics: false,
  dialogSendsAnalytics: false,
  helpDrawerSendsAnalytics: false,
  headerSendsAnalytics: false
});
export var HEALTHCARE_DEFAULTS = _objectSpread(_objectSpread({}, DEFAULTS), {}, {
  errorPlacementDefault: 'bottom',
  headerSendsAnalytics: true
});
var _config = _objectSpread({}, DEFAULTS);
export function config(incomingConfig) {
  Object.assign(_config, incomingConfig);
  return _config;
}
config.DEFAULTS = DEFAULTS;
config.HEALTHCARE_DEFAULTS = HEALTHCARE_DEFAULTS;

// Deprecated stuff

function depWarning(fnName) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn("The '".concat(fnName, "' function is deprecated. Please use the global 'config' function instead."));
  }
}
export function setDefaultAnalyticsFunction(analyticsFunction) {
  depWarning('setDefaultAnalyticsFunction');
  config({
    defaultAnalyticsFunction: analyticsFunction
  });
}
export var defaultAnalyticsFunction = config().defaultAnalyticsFunction;
export function errorPlacementDefault() {
  depWarning('setDefaultAnalyticsFunction');
  return config().errorPlacementDefault;
}
export function setErrorPlacementDefault(value) {
  depWarning('setErrorPlacementDefault');
  config({
    errorPlacementDefault: value
  });
}
export function alertSendsAnalytics() {
  depWarning('alertSendsAnalytics');
  return config().alertSendsAnalytics;
}
export function setAlertSendsAnalytics(value) {
  depWarning('setAlertSendsAnalytics');
  config({
    alertSendsAnalytics: value
  });
}
export function buttonSendsAnalytics() {
  depWarning('buttonSendsAnalytics');
  return config().buttonSendsAnalytics;
}
export function setButtonSendsAnalytics(value) {
  depWarning('setButtonSendsAnalytics');
  config({
    buttonSendsAnalytics: value
  });
}
export function dialogSendsAnalytics() {
  depWarning('dialogSendsAnalytics');
  return config().dialogSendsAnalytics;
}
export function setDialogSendsAnalytics(value) {
  depWarning('setDialogSendsAnalytics');
  config({
    dialogSendsAnalytics: value
  });
}
export function helpDrawerSendsAnalytics() {
  depWarning('helpDrawerSendsAnalytics');
  return config().helpDrawerSendsAnalytics;
}
export function setHelpDrawerSendsAnalytics(value) {
  depWarning('setHelpDrawerSendsAnalytics');
  config({
    helpDrawerSendsAnalytics: value
  });
}